/**
 * Add Player Slots' tabs (Inon, Oct 2 — they replaced the Add menu). Reserved
 * Player Slots is always there — before the team registration is approved it says
 * so, instead of the option going missing; Open Player Slots always; Player Finder
 * Slots last, and only where the team may advertise (Canlan, and the server's
 * opt-in gate, D48).
 *
 * Inon × Jeff, Oct 2 — each tab is named for the slot it adds, so the three read as
 * one family (were Open Slots / Player Finder / Invite Players).
 *
 * Jeff, Oct 2 meeting (F6) — Reserved first: a rep usually knows who is coming
 * back, so naming them is the first thing on offer, then open slots for the rest.
 */
export type AddSlotTab = 'player' | 'player_finder' | 'invited'

export const ADD_SLOT_TAB_LABEL_KEYS: Record<AddSlotTab, string> = {
  player: 'common:balanceAddTabOpen',
  player_finder: 'common:balanceAddTabFinder',
  invited: 'common:balanceAddTabInvite',
}

/** The tabs, in the order they sit. */
export const addSlotTabs = ({
  canAddFinderSlot,
}: {
  canAddFinderSlot: boolean
}): AddSlotTab[] => [
  'invited',
  'player',
  ...(canAddFinderSlot ? (['player_finder'] as const) : []),
]

/**
 * The tab Add Player Slots opens on (F6): Reserved Player Slots when the team may
 * invite, else Open Player Slots — never a tab that can only say why it is locked.
 */
export const initialAddSlotTab = ({
  canInvitePlayers,
}: {
  canInvitePlayers: boolean
}): AddSlotTab => (canInvitePlayers ? 'invited' : 'player')
